var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 90,
    viewBox: "0 0 226 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-brand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-buffalobet",
    filter: "url(#filter0_di_2471_2490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2408 8H25.5694L27.2551 9.68572V17.3919L25.5694 19.0776L27.2551 20.7633V28.4694L25.5694 30.1552H11.2408L11 25.098H11.8429V13.0572H11L11.2408 8ZM18.5857 13.0572V17.2715L20.5123 16.549V13.0572H18.5857ZM18.5857 22.3286V25.098H20.5123V21.6062L18.5857 22.3286Z",
    fill: "url(#paint0_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8901 8H64.2187L64.4595 15.8266H59.4023L59.1615 13.0572H57.235V17.2715L59.1615 16.549V21.6062L57.235 22.3286V25.098H58.0778L57.837 30.1552H49.8901L49.6492 25.098H50.4921V13.0572H49.6492L49.8901 8Z",
    fill: "url(#paint1_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6854 8H67.3568L67.116 13.0572H67.9589V25.098H67.116L67.3568 30.1552H75.3038L75.5446 25.098H74.7017V22.3286L76.6283 21.6062V16.549L74.7017 17.2715V13.0572H76.6283L76.8691 15.8266H81.9262L81.6854 8Z",
    fill: "url(#paint2_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8598 21.6062L91.9333 22.3286V25.098H92.2945L92.0537 30.1552H84.5884L84.3476 25.098H85.1904V9.68572L86.8762 8H98.917L100.603 9.68572V25.098H101.446L101.205 30.1552H93.7394L93.4986 25.098H93.8598V21.6062ZM91.9333 17.2715L93.8358 16.549V13.0572H91.9333V17.2715Z",
    fill: "url(#paint3_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.283 8H104.336L104.095 13.0572H104.938V25.098H104.095L104.336 30.1552H118.665L118.906 22.3286H113.849L113.608 25.098H111.681V13.0572H112.524L112.283 8Z",
    fill: "url(#paint4_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.248 8H135.265L136.95 9.68572H136.975V28.4694L135.289 30.1552H123.248L121.562 28.4694V9.68572L123.248 8ZM128.305 25.098H130.232V13.0572H128.305V25.098Z",
    fill: "url(#paint5_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.822 42.6218C212.361 41.9297 207.404 40.4298 207.404 40.4298L208.327 38.9455C206.756 39.1881 205.543 39.3834 203.716 40.2939L203.716 40.2944C203.715 40.2947 203.714 40.295 203.714 40.2954L203.713 40.2959L203.712 40.2963C200.747 41.8484 199.309 43.3235 198.845 44.5945C198.75 44.8549 198.695 45.1057 198.678 45.3477C198.606 46.2961 199.088 47.0968 199.84 47.6839C200.871 48.4923 202.41 48.8992 203.717 48.7355C203.717 48.7355 201.296 51.0426 197.838 49.889C196.653 49.4579 195.695 48.6352 195.058 47.608C192.611 43.6573 194.101 37.2675 201.35 34.5762C201.35 34.5762 191.498 19.2029 178.358 13.6658L157.38 19.8956L160.031 21.7413L143.894 27.2785L145.162 28.0863L119.573 39.2756C119.573 39.2756 120.841 44.582 115.423 51.5046C115.423 51.5046 119.112 51.0426 123.262 44.3519C123.262 44.3519 120.61 57.7339 111.734 58.6568L108.535 77H119.83L118.009 73.6419C118.009 73.6419 117.195 67.7596 117.496 67.1944C118.265 65.7522 119.034 65.5118 121.936 64.6038C122.517 64.4221 123.183 64.2138 123.951 63.9638C124.884 63.6603 125.902 63.4985 126.996 63.3246C131.309 62.6389 136.81 61.7646 142.97 51.2745C142.97 51.2745 141.702 57.5038 140.088 59.4651C143.776 59.1188 146.888 64.4252 146.888 64.4252L160.338 64.0996L158.646 51.2745L164.117 65.6737L168.347 65.6191L174.646 76.9994L184.004 76.8838L180.985 73.5393L178.933 66.2709L183.894 64.5527L186.31 68.6931L187.578 65.5782L191.496 72.9616L193.341 69.9617C193.341 69.9617 200.372 73.3074 201.525 73.3074C202.678 73.3074 213.051 61.1946 215.126 54.6196C215.126 54.6196 213.282 43.3146 212.821 42.6213L212.822 42.6218ZM203.62 59.0411C203.62 59.0411 202.478 59.9776 201.35 59.117C201.35 59.117 201.378 59.5873 201 60.076C201 60.076 200.108 56.1302 201.462 54.8959C201.462 54.8959 203.901 56.1201 204.682 60.0132C204.682 60.0132 204.15 59.0304 203.62 59.0411Z",
    fill: "url(#paint6_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.778 64.9585C127.778 64.9585 133.172 64.8583 135.507 62.4355V62.4349L141.817 73.4231L145.852 76.9995L134.027 76.4859L127.778 64.9585Z",
    fill: "url(#paint7_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.451 66.3327V76.9995H163.286L160.882 73.5388L160.99 66.3327H152.451Z",
    fill: "url(#paint8_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8483 8.24082H30.1421L29.9013 13.298H30.7442V28.4694L32.4299 30.1552H44.4707L46.1565 28.4694V13.298H46.9993L46.7585 8.24082H39.0524L38.8115 13.298H39.4136V25.098H37.487V13.298H38.0891L37.8483 8.24082Z",
    fill: "url(#paint9_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9 33.4161H80.3172L79.8434 48.8126H87.6601L88.1338 43.3646H90.9763V67.0515H89.3182L89.7919 77H105.425L105.899 67.0515H104.241V43.3646H107.083L107.557 48.8126H115.374L114.9 33.4161Z",
    fill: "url(#paint10_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3775 33.4161H75.565L76.0387 48.8126H66.0902L65.6165 43.3646H61.8266V51.655L65.6165 50.2338V60.1823L61.8266 61.6035V67.0515H65.6165L66.0902 61.6035H76.0387L75.565 77H47.3775L46.9038 67.0515H48.5619V43.3646H46.9038L47.3775 33.4161Z",
    fill: "url(#paint11_linear_2471_2490)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8033 33.4161H11.6159L11.1421 43.3646H12.8002V67.0515H11.1421L11.6159 77H39.8033L43.1195 73.6838V58.5242L39.8033 55.208L43.1195 51.8919V36.7323L39.8033 33.4161ZM26.0649 51.655V43.3646H29.8548V50.2338L26.0649 51.655ZM26.0649 67.0515V61.6035L29.8548 60.1823V67.0515H26.0649Z",
    fill: "url(#paint12_linear_2471_2490)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2471_2490",
    x: 0.656384,
    y: 0.242288,
    width: 224.813,
    height: 89.6872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5859
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.17181
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2471_2490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2471_2490",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.756762
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_2471_2490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2471_2490",
    x1: 113.063,
    y1: 8,
    x2: 113.063,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingLogo);
export default ForwardRef;